<template>
  <div
    ref="pageView"
    class="page-view pd-lr-20 container-view"
    v-loading="loading"
  >
    <section class="title-section fixed-view">
      <e6-title>
        仓库任务监控
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="timeRange">
            <el-date-picker
              v-model="timeRange"
              type="datetimerange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="datePickerOptions"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="reserveCorpName">
            <el-input
              v-model="slotForms.forms.reserveCorpName"
              placeholder="公司名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="vehiclesNum">
            <el-input
              v-model="slotForms.forms.vehiclesNum"
              placeholder="车辆"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="warehouseName">
            <el-input
              v-model="slotForms.forms.warehouseName"
              placeholder="仓库名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="reserveType">
            <el-select
              v-model="slotForms.forms.reserveType"
              placeholder="预约类型"
              clearable
            >
              <el-option label="入库预约" :value="10"> </el-option>
              <el-option label="提货预约" :value="20"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="orderNum">
            <el-input
              v-model="slotForms.forms.orderNum"
              placeholder="预约单号"
              clearable
            ></el-input>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section :style="`height: ${resizeViewHeight - 74}px`" ref="axis">
      <section class="main_content">
        <section class="top_tab">
          <el-radio-group
            v-model="formExtend.forms.reserveStatus"
            size="mini"
            @change="handlesSubmitForm()"
          >
            <template v-for="(v, i) in tabList">
              <el-radio-button :label="v.status" :key="i"
                >{{ v.label }} {{ v.value }}</el-radio-button
              >
            </template>
          </el-radio-group>
        </section>
        <section class="axis">
          <section class="axis_content">
            <template v-for="(v, i) in axisList">
              <div :key="i" class="axis_content_item">
                <div class="order_base_info">
                  <h2 class="order_number">{{ v.orderNum }}</h2>
                  <el-form label-width="75px">
                    <el-form-item :label="`状 态:`">
                      <span :class="`status_${v.reserveStatus}`">{{
                        v.reserveStatusStr
                      }}</span>
                    </el-form-item>
                    <el-form-item label="预约类型:">
                      <span>{{ v.reserveTypeStr }}</span>
                    </el-form-item>
                    <el-form-item label="预约仓库:">
                      <span>{{ v.warehouseName }}</span>
                    </el-form-item>
                    <el-form-item label="预约时间:">
                      <span>{{ v.reserveTimeStr }}</span>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="order_detail_info">
                  <el-row :gutter="20">
                    <el-col :span="6">
                      <span class="cGray"> 车牌号:</span>
                      <span>{{ v.vehiclesNum }} </span>
                    </el-col>
                    <el-col :span="6">
                      <span class="cGray"> 司机姓名:</span>
                      <span>{{ v.driverName }} </span>
                    </el-col>
                    <el-col :span="6">
                      <span class="cGray"> 司机电话:</span>
                      <span>{{ v.driverPhone }} </span>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="7">
                      <span class="cGray"> 公司名称:</span>
                      <span>{{ v.warehouseName }} </span>
                    </el-col>
                    <el-col :span="8">
                      <span class="cGray"> 仓库地址:</span>
                      <span>{{ v.warehouseAddress }} </span>
                    </el-col>
                  </el-row>
                  <div class="axis_line">
                    <!-- 入库预约 -->
                    <ul class="axis_ul" v-if="v.reserveType === 10">
                      <!-- 如果状态是已取消 -->
                      <template v-if="v.reserveStatus === 80">
                        <li
                          v-for="(item, index) in cancelNodeList"
                          :key="index"
                          :class="{
                            active_node:
                              index == 0 ||
                              setActive(v.reserveStatus, item.value)
                          }"
                        >
                          <div class="dot">
                            <span class="dot_icon">
                              <i :class="`node_icon_${item.value}`"></i>
                            </span>
                            <p class="node-name">{{ item.label }}</p>
                            <p class="node-time">{{ v[item.time] }}</p>
                          </div>
                          <!-- <i
                          :class="[
                            'vehicleIcon',
                            {
                              vehicleHidden:
                                v.reserveStatus == 60 && v.completionTime
                            }
                          ]"
                          v-if="index * 10 + 10 == v.reserveStatus"
                        ></i> -->
                        </li>
                      </template>
                      <!-- 如果状态是已拒绝 -->
                      <template v-else-if="v.reserveStatus === 70">
                        <li
                          v-for="(item, index) in rejectNodeList"
                          :key="index"
                          :class="{
                            active_node:
                              index == 0 ||
                              setActive(v.reserveStatus, item.value)
                          }"
                        >
                          <div class="dot">
                            <span class="dot_icon">
                              <i :class="`node_icon_${item.value}`"></i>
                            </span>
                            <p class="node-name">{{ item.label }}</p>
                            <p class="node-time">{{ v[item.time] }}</p>
                          </div>
                          <i
                            :class="[
                              'vehicleIcon',
                              {
                                vehicleHidden: v.reserveStatus == 70
                              }
                            ]"
                            v-if="index * 10 + 10 == v.reserveStatus"
                          ></i></li
                      ></template>
                      <!-- 其他状态 -->
                      <template v-else>
                        <li
                          v-for="(item, index) in nodeList"
                          :key="index"
                          :class="{
                            active_node:
                              index == 0 ||
                              setActive(v.reserveStatus, item.value)
                          }"
                        >
                          <div class="dot">
                            <span class="dot_icon">
                              <i :class="`node_icon_${item.value}`"></i>
                            </span>
                            <p class="node-name">{{ item.label }}</p>
                            <p class="node-time">{{ v[item.time] }}</p>
                          </div>
                          <i
                            :class="[
                              'vehicleIcon',
                              {
                                vehicleHidden: v.reserveStatus == 60
                              }
                            ]"
                            v-if="index * 10 + 10 == v.reserveStatus"
                          ></i>
                        </li>
                      </template>
                    </ul>
                    <!-- 提货预约 -->
                    <ul class="axis_ul" v-else-if="v.reserveType === 20">
                      <!-- 如果状态是已取消 -->
                      <template v-if="v.reserveStatus === 80">
                        <li
                          v-for="(item, index) in cancelNodeList"
                          :key="index"
                          :class="{
                            active_node:
                              index == 0 ||
                              setActive(v.reserveStatus, item.value)
                          }"
                        >
                          <div class="dot">
                            <span class="dot_icon">
                              <i :class="`node_icon_${item.value}`"></i>
                            </span>
                            <p class="node-name">{{ item.label }}</p>
                            <p class="node-time">{{ v[item.time] }}</p>
                          </div>
                          <!-- <i
                          :class="[
                            'vehicleIcon',
                            {
                              vehicleHidden:
                                v.reserveStatus == 60 && v.completionTime
                            }
                          ]"
                          v-if="index * 10 + 10 == v.reserveStatus"
                        ></i> -->
                        </li>
                      </template>
                      <!-- 如果状态是已拒绝 -->
                      <template v-else-if="v.reserveStatus === 70">
                        <li
                          v-for="(item, index) in outRejectNodeList"
                          :key="index"
                          :class="{
                            active_node:
                              index == 0 ||
                              setActive(v.reserveStatus, item.value)
                          }"
                        >
                          <div class="dot">
                            <span class="dot_icon">
                              <i :class="`node_icon_${item.value}`"></i>
                            </span>
                            <p class="node-name">{{ item.label }}</p>
                            <p class="node-time">{{ v[item.time] }}</p>
                          </div>
                          <i
                            :class="[
                              'vehicleIcon',
                              {
                                vehicleHidden: v.reserveStatus == 70
                              }
                            ]"
                            v-if="index * 10 + 10 == v.reserveStatus"
                          ></i></li
                      ></template>
                      <!-- 其他状态 -->
                      <template v-else>
                        <li
                          v-for="(item, index) in outNodeList"
                          :key="index"
                          :class="{
                            active_node:
                              index == 0 ||
                              setActive(v.reserveStatus, item.value)
                          }"
                        >
                          <div class="dot">
                            <span class="dot_icon">
                              <i :class="`node_icon_${item.value}`"></i>
                            </span>
                            <p class="node-name">{{ item.label }}</p>
                            <p class="node-time">{{ v[item.time] }}</p>
                          </div>
                          <i
                            :class="[
                              'vehicleIcon',
                              {
                                vehicleHidden: v.reserveStatus == 60
                              }
                            ]"
                            v-if="index * 10 + 10 == v.reserveStatus"
                          ></i>
                        </li>
                      </template>
                    </ul>
                  </div>
                  <div
                    class="order_detail_btn"
                    @click="
                      $router.push({
                        path: '/storageInfo',
                        query: {
                          orderNum: v.orderNum,
                          taskType: v.reserveType,
                          primaryKeyId: v.primaryKeyId
                        }
                      })
                    "
                  >
                    运单详情
                  </div>
                </div>
              </div>
            </template>
          </section>
        </section>
      </section>
    </section>
    <!-- 翻页 -->
    <section class="pagination-section">
      <e6-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :pageSize.sync="searchForm.pageSize"
        :pageSizes="[10, 20, 50]"
        :currentPage.sync="searchForm.curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import _ from "lodash";
import {
  FetchStorageTaskByPage,
  FetchStorageTaskTabInfo
} from "@/api/monitorCenter/storageTask";
import operationManage from "_private/mixins/operationManage";
import { mergeFormExtend } from "_private/utils/merge";
import { datePickerOptionsNotContainToday } from "@/utils/dateUtil.js";
import resizeListener from "_private/mixins/resizeListener";
import listInit from "@/mixins/listInit";

import moment from "moment";

export default {
  mixins: [resizeListener, operationManage, listInit],
  data() {
    return {
      loading: false,
      isSearch: false,
      vehicleList: [], // 车辆下拉数据源
      tabList: [
        {
          label: "全部",
          status: -1,
          value: 0
        },
        {
          label: "待报到",
          status: 10,
          value: 0
        },
        {
          label: "待采检",
          status: 20,
          value: 0
        },
        {
          label: "待消毒",
          status: 30,
          value: 0
        },
        {
          label: "待检测",
          status: 40,
          value: 0
        },
        {
          label: "进行中",
          status: 50,
          value: 0
        },
        {
          label: "已完成",
          status: 60,
          value: 0
        },
        {
          label: "已拒绝",
          status: 70,
          value: 0
        },
        {
          label: "已取消",
          status: 80,
          value: 0
        }
      ],
      /**************************入库预约 step***************************** */
      nodeList: [
        {
          label: "创建预约",
          value: -1,
          time: "createReserveTime"
        },
        {
          label: "入库报到",
          value: 10,
          time: "registerTime"
        },
        {
          label: "入库采检",
          value: 20,
          time: "samplingInspectionTime"
        },
        {
          label: "入库消毒",
          value: 30,
          time: "disinfectionTime"
        },
        {
          label: "入库检测",
          value: 40,
          time: "detectionTime"
        },
        {
          label: "已完成",
          value: 60,
          time: "completionTime"
        }
      ],
      rejectNodeList: [
        {
          label: "创建预约",
          value: -1,
          time: "createReserveTime"
        },
        {
          label: "入库报到",
          value: 10,
          time: "registerTime"
        },
        {
          label: "入库采检",
          value: 20,
          time: "samplingInspectionTime"
        },
        {
          label: "入库消毒",
          value: 30,
          time: "disinfectionTime"
        },
        {
          label: "入库检测",
          value: 40,
          time: "detectionTime"
        },
        {
          label: "已拒绝",
          value: 70,
          time: "completionTime"
        }
      ],
      /**************************入库预约 step end****************************/
      /**************************出库预约 step***************************** */
      outNodeList: [
        {
          label: "创建预约",
          value: -1,
          time: "createReserveTime"
        },
        {
          label: "提货报到",
          value: 10,
          time: "registerTime"
        },
        {
          label: "提货消毒",
          value: 30,
          time: "disinfectionTime"
        },
        {
          label: "已完成",
          value: 60,
          time: "completionTime"
        }
      ],
      outRejectNodeList: [
        {
          label: "创建预约",
          value: -1,
          time: "createReserveTime"
        },
        {
          label: "提货报到",
          value: 10,
          time: "registerTime"
        },
        {
          label: "提货消毒",
          value: 30,
          time: "disinfectionTime"
        },
        {
          label: "已拒绝",
          value: 70,
          time: "completionTime"
        }
      ],
      /**************************入库预约 step end****************************/
      //取消状态
      cancelNodeList: [
        {
          label: "创建预约",
          value: -1,
          time: "createReserveTime"
        },
        {
          label: "已取消",
          value: 80,
          time: "completionTime"
        }
      ],
      timeRange: [
        moment()
          .subtract(1, "day")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        moment()
          .subtract(1, "day")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
      ],
      formExtend: {
        forms: {
          beginTime: "",
          endTime: "",
          reserveCorpName: "",
          warehouseName: "",
          vehiclesNum: "",
          orderNum: "",
          reserveType: "", // 0: 入库
          reserveStatus: -1
        },
        extends: []
      },
      searchForm: {
        pageSize: 20,
        curPage: 1
      },
      total: 0,
      formsExtend: [],
      axisList: [],
      // 表格列相关
      columSetVisible: false,
      multipleSelection: [],
      datePickerOptions: datePickerOptionsNotContainToday
    };
  },

  created() {
    this.getPageData();
    this.setSearchFormIsOpenAct();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 检验时间40天
    validataTime() {
      let start = moment(this.timeRange[0]);
      let end = moment(this.timeRange[1]);
      //判断时间间隔不能大于40天
      if (end.diff(start, "days") > 39) {
        this.$message.warning("开始时间与结束时间间隔不能大于40天！");
        return false;
      } else {
        return true;
      }
    },
    // 查询tab数据
    async getTabInfoData() {
      try {
        if (this.timeRange) {
          this.formExtend.forms.beginTime = this.timeRange[0];
          this.formExtend.forms.endTime = this.timeRange[1];
        } else {
          this.formExtend.forms.beginTime = "";
          this.formExtend.forms.endTime = "";
        }
        let params = _.cloneDeep(this.formExtend);
        params.forms.reserveStatus = "";
        params = Object.assign({}, mergeFormExtend(params), {
          pageParamVO: {
            curPage: this.searchForm.curPage,
            pageSize: this.searchForm.pageSize
          }
        });
        let tabInfo = await FetchStorageTaskTabInfo(params);
        if (tabInfo.code) {
          this.tabList[0].value = tabInfo.result.total;
          this.tabList[1].value = tabInfo.result.toBeReported;
          this.tabList[2].value = tabInfo.result.toBeInspected;
          this.tabList[3].value = tabInfo.result.toBeDisinfected;
          this.tabList[4].value = tabInfo.result.toBeTested;
          this.tabList[5].value = tabInfo.result.inProgress;
          this.tabList[6].value = tabInfo.result.complete;
          this.tabList[7].value = tabInfo.result.rejected;
          this.tabList[8].value = tabInfo.result.cancelled;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 查询数据
    async getPageData() {
      try {
        this.loading = true;
        this.axisList = [];
        this.getTabInfoData();
        let res = await FetchStorageTaskByPage(this.mergeObj());
        if (res.code) {
          this.axisList = _.cloneDeep(res.result.data);
          this.total = res.result.totalRecords;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    setActive(status, nodeValue) {
      if (status > nodeValue) {
        return true;
      } else {
        if (status == 60 || status == 70 || status == 80) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 整合查询数据
    mergeObj() {
      if (this.timeRange) {
        this.formExtend.forms.beginTime = this.timeRange[0];
        this.formExtend.forms.endTime = this.timeRange[1];
      } else {
        this.formExtend.forms.beginTime = "";
        this.formExtend.forms.endTime = "";
      }
      let params = _.cloneDeep(this.formExtend);
      if (params.forms.reserveStatus == -1) {
        params.forms.reserveStatus = "";
      }
      return Object.assign({}, mergeFormExtend(params), {
        pageParamVO: {
          curPage: this.searchForm.curPage,
          pageSize: this.searchForm.pageSize
        }
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.getPageData();
    },
    // 重置
    handleResetForm() {
      this.timeRange = [
        moment()
          .subtract(1, "day")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        moment()
          .subtract(1, "day")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
      ];
      this.formExtend.forms.reserveCorpName = "";
      this.formExtend.forms.warehouseName = "";
      this.formExtend.forms.vehiclesNum = "";
      this.formExtend.forms.orderNum = "";
      this.formExtend.forms.reserveType = "";
      this.formExtend.forms.reserveStatus = -1;
      this.searchForm.curPage = 1;
      this.searchForm.pageSize = 20;
    },
    // 翻页
    handleCurrentChange(e) {
      this.searchForm.curPage = e;
      this.getPageData();
      this.$refs.axis.scrollTop = 0; //滚动条回到顶部
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.searchForm.curPage = 1;
      this.pageSize = e;
      this.getPageData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}
.cGray {
  color: #adb0b5;
}
.title-section {
  padding: 15px 0 10px;
}
/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_line {
    color: #fff !important;
  }
}
.main_content {
  box-sizing: border-box;
  padding: 0 0px;
  height: calc(100%);
  background: #fff;
  .top_tab {
    padding: 16px 20px;
    /deep/ .el-radio-button {
      margin-right: 20px;
      .el-radio-button__inner {
        padding: 7px 15px;
        border: none;
        border-radius: 15px;
        background: #edf0f5;
        box-shadow: none;
        color: #999999;
        font-size: 12px;
      }
      &.is-active {
        .el-radio-button__inner {
          background-image: linear-gradient(to right, #3840f4, #076aed);
          box-shadow: none;
          border: none;
          color: #fff;
        }
      }
    }
  }
  .axis {
    box-sizing: border-box;
    padding: 0 20px;
    height: calc(100% - 56px);
    overflow: auto;
  }
  .axis_content {
    &_item {
      margin-bottom: 10px;
      height: 190px;
      border: 1px solid #e8e8e8;
      border-radius: 6px;
      background: #f6faff;
      .order_base_info,
      .order_detail_info {
        position: relative;
        box-sizing: border-box;
        height: 100%;
        padding: 20px 15px;
        float: left;
      }
      .order_base_info {
        width: 280px;
        border-right: 1px solid #e8e8e8;
        .order_number {
          margin: 0 0 10px 0;
          font-size: 16px;
          color: #333;
        }
        $colors: (10, #ff9933), (20, #0066ff), (30, #6f7ad3), (40, #8c00ff),
          (50, #25a0df), (60, #33cc00), (70, #f56c6c), (80, #909399);
        @each $i, $color in $colors {
          .status_#{$i} {
            color: $color;
            font-weight: 600;
          }
        }
        /deep/ .el-form {
          .el-form-item {
            margin-bottom: 5px;
          }
          .el-form-item__content {
            font-size: 14px;
          }
          .el-form-item__label {
            font-size: 14px;
            color: #adb0b5;
          }
        }
      }
      .order_detail_info {
        width: calc(100% - 280px);
        .el-row {
          margin-bottom: 15px;
        }
        // 轴线
        .axis_line {
          width: 100%;
          height: calc(100% - 62px);
          .axis_ul {
            width: 100%;
            height: 100%;
            position: relative;
            right: 5%;
            > li {
              position: relative;
              width: 16.5%;
              height: 100%;
              float: left;
              &:before,
              &:after {
                position: relative;
                display: inline-block;
                content: "";
                width: 50%;
                height: 5px;
                left: 7%;
                top: 5px;
                background: #a6a9ae;
              }
              .dot {
                width: 80%;
                height: 100%;
                position: absolute;
                left: 50%;
                top: -2px;
                color: #adb0b5;
                .dot_icon {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: absolute;
                  top: 0%;
                  width: 35px;
                  height: 35px;
                  border-radius: 50%;
                  background-image: linear-gradient(#b9b9ba, #a7aaae);
                  z-index: 100;
                  i {
                    display: inline-block;
                    width: 18px;
                    height: 18px;
                    background: url("~@/assets/images/storageTask/node_icon.png")
                      center no-repeat;
                  }
                }
                .node-name {
                  margin: 0 0 10px 0;
                  position: absolute;
                  bottom: 15px;
                  left: -12px;
                }
                .node-time {
                  margin: 0;
                  position: absolute;
                  bottom: 0px;
                  left: -32px;
                }
              }
              .vehicleIcon {
                display: inline-block;
                position: absolute;
                right: -27px;
                top: 7px;
                width: 26px;
                height: 17px;
                background: url("~@/assets/images/storageTask/vehicle_icon.png")
                  center no-repeat !important;
                z-index: 100;
              }
              .vehicleHidden {
                display: none;
              }
            }
            li:first-child {
              &:before {
                display: none;
              }
              &:after {
                left: 60%;
              }
            }
            li:last-child {
              &:after {
                display: none;
              }
            }
            // 点亮的节点
            li {
              &.active_node {
                .dot {
                  .node-name {
                    color: #0066ff;
                  }
                  .dot_icon {
                    background-image: linear-gradient(#076aed, #3840f4);
                  }
                }
                @each $i in -1, 10, 20, 30, 40, 60, 70, 80 {
                  .node_icon_#{$i} {
                    background: url("~@/assets/images/storageTask/node_icon_#{$i}.png")
                      center
                      no-repeat !important;
                  }
                }
              }
            }
            li.active_node::before {
              background: #006fec;
            }
            li.active_node::after {
              background: #006fec;
            }
          }
        }
        .order_detail_btn {
          position: absolute;
          top: 15px;
          right: 0;
          width: 20px;
          padding: 5px 2px;
          background-image: linear-gradient(#fc8436, #fc6a37);
          color: #fff;
          text-align: center;
          border-top-left-radius: 5px;
          border-bottom-left-radius: 5px;
          cursor: pointer;
        }
      }
    }
  }
}
/deep/ .pagination-section {
  position: absolute;
  width: calc(100% - 40px);
  bottom: 0;
  .e6-pagination {
    box-shadow: 0 0 10px #ccc;
  }
}
</style>
